<template>
    <div>
        <!-- Start Footer Area -->
        <footer class="text-white">
            <div class="container">
                <a class="footer-logo" href="#top" title="">
                    <img src="../assets/images/ma-logo.svg" width=400 alt="" class="img-fluid" />
                </a>
				
                <!-- <ul class="social-links list-unstyled d-flex justify-content-center">
                    <li class="facebook">
                        <a href="" title="Facebook" target="_blank">
                            <i class="mdi mdi-facebook font-20 text-white"></i>
                        </a>
                    </li> 
                    <li class="twitter">
                        <a href="" title="LinkedIn" target="_blank">
                            <i class="mdi  mdi-linkedin font-20 text-white"></i>
                        </a>
                    </li>
                    <li class="instagram">
                        <a href="" title="Instagram" target="_blank">
                            <i class="mdi  mdi-instagram font-20 text-white"></i>
                        </a>
                    </li> 
                </ul> -->
                <nav>
                    <div class="menu-footer-menu-container mt-4">
                        <ul class="menu list-unstyled">
                            <li class="menu-item">
                                <router-link to="/">
                                    <span class="line">Home</span>
                                </router-link>
                            </li>
							<li class="menu-item">
                                <router-link to="/about">
                                    <span class="line">About Us</span>
                                </router-link>
                            </li>
							<!-- <li class="menu-item">
                                <router-link to="/services">
                                    <span class="line">Services</span>
                                </router-link>
                            </li> -->
							<li class="menu-item">
								<router-link to="/capabilities">
                                    <span class="line">Capabilities</span>
								</router-link>
                            </li>
							<li class="menu-item">
                                <router-link to="/blog">
                                    <span class="line">News/Publications</span>
                                </router-link>
                            </li>
							<li class="menu-item">
                                <router-link to="/contact">
                                    <span class="line">Contact Us</span>
                                </router-link>
                            </li>
                            <li class="menu-item">
                                <router-link to="/privacy">
                                    <span class="line">Privacy</span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div class="copyright mt-4">
                    <p>
                        &copy; 2024 MoveAmerica. All information presented in this platform are the property of MoveAmerica. Duplication and copy of this information is strictly prohibited. All rights reserved. 
                    </p>
                </div>
            </div>
        </footer>
        <!-- End Footer Area -->
        <!-- Back To Top -->
        <a href="#" class="back_top"> <i class="mdi mdi-chevron-up"></i></a>
    </div>
</template>
<script>
    export default {
        name: "template_footer",
        methods: {
        }
    }
</script>
